import { API_SYNC_DELAY_MS } from '@/constants/constants';

export const PAST_EXPORTS_REFETCH_DELAY_MS = API_SYNC_DELAY_MS;
